import styles from './industry.module.scss';
import {Search, Button} from '@dabafinance/react-components';
import {useNavigate} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import {GET_ALL_REPORT} from 'graphql/queries/report';
import {DELETE_REPORT} from 'graphql/mutations/report';
import {Spin} from 'antd';
import {toast} from 'react-toastify';
import pageNotFound from 'images/pageNotFound.png';
import ResearchReportCard from 'components/researchReportCard';
import {NavTabsEnum} from 'utils/constants';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';

const Industry = () => {
  const navigate = useNavigate();

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Report),
  );

  const {data, loading} = useQuery(GET_ALL_REPORT, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const handleNavigation = id => {
    navigate(`/dashboard/report/industry/${id}`);
  };

  const [deleteReport] = useMutation(DELETE_REPORT);

  const handleDelete = id => {
    deleteReport({
      variables: {
        reportId: id,
      },
      refetchQueries: [{query: GET_ALL_REPORT}],
    }).then(({data: {deleteReport}}) => {
      if (deleteReport.__typename === 'Error') {
        toast.error(deleteReport.message);
      } else {
        toast.success('Deleted Successfully');
        navigate('/dashboard/report');
      }
    });
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>All Reports</h2>
        <div className={styles.actions}>
          <Search
            id="search-reports"
            placeholder="Search Report"
            onChange={() => {}}
            className={styles.search}
          />
          <Button
            type="primary"
            label="Add New Report"
            className={styles.button}
            onClick={() => navigate('/dashboard/report/newIndustry')}
          />
        </div>
      </div>
      <div className={styles['report-grid']}>
        {data?.getAllReports?.filter(item => item?.type === 'INDUSTRY')
          ?.length > 0 ? (
          data?.getAllReports
            ?.filter(item => item?.type === 'INDUSTRY')
            ?.map(({id, title, relatedIndustry, createdAt}) => (
              <ResearchReportCard
                key={id}
                title={title}
                related={relatedIndustry}
                operations={tabOperations}
                createdAt={createdAt}
                onHandle={() => handleNavigation(id)}
                onDelete={() => handleDelete(id)}
              />
            ))
        ) : (
          <div className={styles['no-update']}>
            <img src={pageNotFound} alt="" />
            <h1>No Report</h1>
            <span>Add a new Industry Report</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Industry;
